import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { PageTransition } from "./components/PageTransition";
import KQuantSmartInsightsPage from "./pages/KQuantSmartInsightsPage/KQuantSmartInsightsPage";
import SmartInsightsConversationPage from "./pages/KQuantSmartInsightsPage/SmartInsightsConversationPage";
import HomePage from "./pages/HomePage/HomePage";
import MyQuantFlowsPage from "./pages/MyQuantFlowsPage/MyQuantFlowsPage";
import FlowAppRouter from "./pages/MyQuantFlowsPage/FlowAppRouter";
import StrategiesDemoPage from "./pages/StrategiesDemoPage/StrategiesDemoPage";
import FlowDebugPage from "./pages/FlowDebugPage/FlowDebugPage";

export default function App() {
  const location = useLocation();
  return (
    <ErrorBoundary>
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<HomePage />} />
          <Route
            path="/smart-insights"
            element={
              <PageTransition>
                <KQuantSmartInsightsPage />
              </PageTransition>
            }
          />
          <Route
            path="/smart-insights/chat"
            element={
              <PageTransition>
                <SmartInsightsConversationPage />
              </PageTransition>
            }
          />
          <Route path="/strategies" element={<StrategiesDemoPage />} />
          <Route path="/my-quant-flows" element={<MyQuantFlowsPage />} />
          <Route path="/my-quant-flows/*" element={<FlowAppRouter />} />
          <Route path="/flow-debug" element={<FlowDebugPage />} />
        </Routes>
      </AnimatePresence>
    </ErrorBoundary>
  );
}
